var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadsetHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0498 11C20.0498 6.58172 16.4681 3 12.0498 3C7.63153 3 4.0498 6.58172 4.0498 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0498 15.4384V13.5616C2.0498 12.6438 2.6744 11.8439 3.56473 11.6213L5.30428 11.1864C5.68297 11.0917 6.0498 11.3781 6.0498 11.7685V17.2315C6.0498 17.6219 5.68297 17.9083 5.30428 17.8136L3.56473 17.3787C2.6744 17.1561 2.0498 16.3562 2.0498 15.4384Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0498 15.4384V13.5616C22.0498 12.6438 21.4252 11.8439 20.5349 11.6213L18.7953 11.1864C18.4166 11.0917 18.0498 11.3781 18.0498 11.7685V17.2315C18.0498 17.6219 18.4166 17.9083 18.7953 17.8136L20.5349 17.3787C21.4252 17.1561 22.0498 16.3562 22.0498 15.4384Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0498 18V18.5C20.0498 19.6046 19.1544 20.5 18.0498 20.5H14.5498",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5498 22H10.5498C9.72138 22 9.0498 21.3284 9.0498 20.5C9.0498 19.6716 9.72138 19 10.5498 19H13.5498C14.3782 19 15.0498 19.6716 15.0498 20.5C15.0498 21.3284 14.3782 22 13.5498 22Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetHelp);
export default __webpack_public_path__ + "static/media/headset-help.5c70e4ba96ebde0220dfe8aa5bf4dd85.svg";
export { ForwardRef as ReactComponent };